import { useQuery } from 'react-query';
import { network } from 'services/network';
import { QueryKeys } from 'api/queryKeys';
import qs from 'qs';

const queryFn = (params: QueryParams) => {
    const querystring = qs.stringify(params, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getSubProgramPreferencePartialCompletion${querystring}`;
    return network.get(url).then((response) => response.data);
};

export const useQueryGetSubProgramPreferencePartialCompletion = (params: QueryParams) => {
    return useQuery<Boolean, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getSubProgramPreferencePartialCompletion', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.subProgramId),
        select: (data) => {
            return data ? 'true' : 'false';
        },
    });
};

interface QueryParams {
    subProgramId?: number;
}

export type QueryResponse = 'true' | 'false';
